var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-login"
  }, [_c("div", {
    staticClass: "page-login--layer page-login--layer-area"
  }, [_c("ul", {
    staticClass: "circles"
  }, _vm._l(10, function (n) {
    return _c("li", {
      key: n
    });
  }), 0)]), _c("div", {
    staticClass: "page-login--layer page-login--layer-time",
    attrs: {
      flex: "main:center cross:center"
    }
  }, [_vm._v(" " + _vm._s(_vm.time) + " ")]), _vm._m(0)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-login--layer"
  }, [_c("div", {
    staticClass: "page-login--content",
    attrs: {
      flex: "dir:top main:justify cross:stretch box:justify"
    }
  }, [_c("div", {
    staticClass: "page-login--content-header"
  }, [_c("p", {
    staticClass: "page-login--content-header-motto"
  }, [_vm._v(" 时间是一切财富中最宝贵的财富 ")])]), _c("div", {
    staticClass: "page-login--content-main",
    attrs: {
      flex: "dir:top main:center cross:center"
    }
  }), _c("div", {
    staticClass: "page-login--content-footer"
  })])]);
}];
render._withStripped = true;
export { render, staticRenderFns };